// extracted by mini-css-extract-plugin
export default {"settingName":"FieldDefinitions_settingName__xCHpb","indent":"FieldDefinitions_indent__gJBZc","paddingDropdownOption":"FieldDefinitions_paddingDropdownOption__pDSsg"};